<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity end line (second line in a block)          -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <!-- parent display -->
  <v-row dense :class="$options.name" v-if="hasTrueChildren">
    <!--    <v-col cols="2">{{ time(dutyActivity.toMinutesAfterMidnight) }}</v-col>-->
    <v-col cols="2">{{ lastChildTime }}</v-col>
    <v-col cols="3">{{ dutyActivity._endStop && dutyActivity._endStop.shortname }}</v-col>
    <v-col cols="7">{{ lastChildStop }}</v-col>
  </v-row>

  <!-- child display -->
  <v-row dense :class="$options.name" v-else-if="nextDutyActivity">
    <v-col cols="2">{{ time(dutyActivity.toMinutesAfterMidnight) }}</v-col>
    <v-col cols="3">{{ dutyActivity._endStop && dutyActivity._endStop.shortname }}</v-col>
    <v-col cols="2">{{ nextDutyActivity ? time(nextDutyActivity.fromMinutesAfterMidnight) : '' }}</v-col>
    <!--    <v-col cols="2">{{ dutyStopsById[dutyActivity.endStopIdFk].shortname }}</v-col>-->
    <v-col cols="3">{{ nextDutyActivity && nextDutyActivity._startStop && nextDutyActivity._startStop.shortname }}</v-col>
    <v-col cols="2" class="dense-course">{{ dutyActivity.blockcode }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivityEnd_Blt',
  props: {
    dutyActivity: Object,
    nextDutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    isParent: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    lastChildStop() {
      let lastItem = this.getLastItemSafely(this.dutyActivity.children);
      return lastItem && lastItem._endStop ? lastItem._endStop.shortname : '';
    },
    lastChildTime() {
      let lastItem = this.getLastItemSafely(this.dutyActivity.children);
      return lastItem && lastItem.toMinutesAfterMidnight ? this.time(lastItem.toMinutesAfterMidnight) : '';
    },
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
    getLastItemSafely(arr) {
      if (arr && arr.length > 0) {
        return arr[arr.length - 1];
      }
      return null;
    },
  },
};
</script>
